module.exports = __webpack_public_path__ + "static/img/partner14.a604a32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner14.png
// module id = GNod
// module chunks = 0